import React from 'react';
import styled from 'styled-components';
import { TrevorComponent } from '@trevor/ui-components';

export type ConfigurationSectionTitleProps = {
  isOptional?: boolean;
};

const _ConfigurationSectionTitle: TrevorComponent<
  ConfigurationSectionTitleProps,
  string
> = ({ className, children, isOptional = false }) => (
  <h4 className={className}>
    {children}
    {isOptional && <span>(Optional)</span>}
    <div />
  </h4>
);

export const ConfigurationSectionTitle = styled(_ConfigurationSectionTitle)`
  width: 100%;
  display: flex;
  align-items: center;
  font-weight: 700;
  font-size: 16px;
  margin-bottom: calc(var(--spacing-m) * 2);

  > span {
    font-weight: 400;
    color: #93939c;
    margin-left: var(--spacing-xs);
  }

  > div {
    height: 1px;
    flex-grow: 1;
    background-color: #c7c7c7;
    margin-left: var(--spacing-l);
  }
`;
